export type AlignedCourses = {
  [gradeValue in number]: {
    [subjectKey in number]: {
      checked: boolean
      publisher: string
    }
  }
}

export type StandardCourses = {
  [subjectCode in number]: boolean
}
export interface StudentInfo {
  nickname?: string
  studentCode?: string
  schoolSelected?: string
  gradeSelected?: string
  alignedCourses?: AlignedCourses
  standardCourses?: StandardCourses
  date?: string
  month?: string
}

interface StudentInfoState {
  studentInfo: StudentInfo
}

const state: StudentInfoState = {
  studentInfo: {},
}

const getters = {
  studentInfo: (state: StudentInfoState) => state.studentInfo,
}

const mutations = {
  setStudentInfo(state: StudentInfoState, payload: StudentInfo) {
    state.studentInfo = { ...state.studentInfo, ...payload }
  },
  resetStudentInfo(state: StudentInfoState) {
    state.studentInfo = {}
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
